// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u2hn","field":"styles_field__22Gsa","fieldCol":"styles_fieldCol__bPp8s","diffCol":"styles_diffCol__7w6mQ","diff":"styles_diff__3pCbP"};